import { Reveal, Eyebrow } from "@/components/Reveal";

const categories = [
  {
    title: "Outdoor",
    desc: "Quad, buggy, randonnée, équitation…",
    image: "https://images.unsplash.com/photo-1553966012-dd33086ea262?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    testid: "forwho-outdoor",
  },
  {
    title: "Nautique",
    desc: "Jet-ski, bateau, surf, plongée…",
    image: "https://images.unsplash.com/photo-1564633351631-e85bd59a91af?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    testid: "forwho-nautique",
  },
  {
    title: "Loisirs",
    desc: "Karting, expériences, activités diverses…",
    image: "https://images.unsplash.com/photo-1569748185840-3ed442d1c2fb?crop=entropy&cs=srgb&fm=jpg&ixlib=rb-4.1.0&q=85",
    testid: "forwho-loisirs",
  },
  {
    title: "Excursions & Tours",
    desc: "Agences, guides, tours opérateurs, expériences touristiques…",
    image: "https://images.pexels.com/photos/5976712/pexels-photo-5976712.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    testid: "forwho-excursions",
  },
];

const ForWho = () => (
  <section data-testid="for-who-section" id="pour-qui" className="scroll-mt-24 bg-white py-16 sm:py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="max-w-3xl">
        <Eyebrow index="06">Pour qui ?</Eyebrow>
        <h2 className="mt-4 text-balance text-3xl font-bold tracking-tight text-navy sm:text-4xl">
          Pensé pour votre activité.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-navy/60 sm:text-lg">
          Quelle que soit votre discipline, ActiPilote s'adapte à votre exploitation — pas l'inverse.
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {categories.map((c, i) => (
          <Reveal key={c.title} delay={0.07 * i}>
            <div data-testid={c.testid} className="group relative h-72 overflow-hidden rounded-2xl shadow-soft">
              <img src={c.image} alt={c.title} loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-navy/90 via-navy/30 to-transparent" aria-hidden="true" />
              <div className="absolute inset-x-0 bottom-0 p-5">
                <h3 className="text-lg font-bold text-white">{c.title}</h3>
                <p className="mt-1 text-sm text-white/75">{c.desc}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default ForWho;
